export class IGetNewEvent {
  id: number = 0;
  type: string = "";
  category: number = 0;
  categoryName: string = "";
  highlight?: boolean = false;
  fileType?: string = "";
  image?: string = "";
  name: string = "";
  shortDescription: string = "";
  description: string = "";
  dateStart?: string = "";
  timeStart?: string = "";
  dateFinish?: string = "";
  timeFinish?: string = "";
  place?: string = "";
  publish?: boolean = false;
  state?: string = "";
  publishDate?: string = "";
  population?: string = "";

  
  constructor(def: any) {
    this.id = def.id;
    this.name = def.name || "";
    this.type = def.type || "";
    this.category = def.category;
    this.categoryName = def.categoryName || "";
    this.highlight = def.highlight;
    this.fileType = def.fileType;
    this.image = def.image;
    this.name = def.name || "";
    this.shortDescription = def.shortDescription || "";
    this.description = def.description || "";
    this.dateStart = def.dateStart || "";
    this.timeStart = def.timeStart || "";
    this.dateFinish = def.dateFinish = "";
    this.timeFinish = def.timeFinish || "";
    this.place = def.place || "";
    this.publish = def.publish;
    this.state = def.state || "";
    this.publishDate = def.publishDate || "";
    this.population = def.population || "";
  }
    
}